import Message from "../../message";
import {useMainStore} from "@/store";

export default class MemberSeasonPointsGained extends Message
{
    handle()
    {
        useMainStore().INCREMENT_MEMBER_SEASON_POINTS(this.message);
    }
}
